/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input, OnInit } from '@angular/core';
import { RestService } from '../../modules/shared/services/rest.service';
import { switchMap, take } from 'rxjs/operators';
import { StorageService } from '../../modules/shared/services/storage.service';
import { StorageDirectUrl, StorageFile } from '../../types';
import { ShowError } from '../../core/state/notification/notification.actions';
import { EMPTY } from 'rxjs';
import { Store } from '@ngxs/store';

@Component({
    selector: 'dash-gis-document-link',
    templateUrl: './document-link.component.html',
    styleUrls: ['./document-link.component.scss'],
})
export class DocumentLinkComponent implements OnInit {
    @Input() path: string;
    @Input() label: string;
    @Input() asLink = true;

    constructor(private store: Store, private storageService: StorageService, private rest: RestService) {}

    ngOnInit(): void {}

    getFile() {
        this.rest
            .apiGet<StorageFile | StorageDirectUrl>('document', { path: this.path })
            .pipe(
                take(1),
                switchMap((storageObject) => {
                    if (storageObject['content'] !== undefined) {
                        return this.storageService.handleBlob(storageObject as StorageFile);
                    } else if (storageObject['url'] !== undefined) {
                        return this.storageService.handleUrl(storageObject as StorageDirectUrl);
                    } else {
                        this.store.dispatch(new ShowError('Invalid response when retrieving file.'));
                        return EMPTY;
                    }
                })
            )
            .subscribe();
    }
}
